import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Box = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="box">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29007 3.93379C4.72943 3.05507 5.62755 2.5 6.60999 2.5H17.39C18.3724 2.5 19.2706 3.05507 19.7099 3.93379L21.1701 6.8541C21.2715 7.05684 21.3501 7.26931 21.4052 7.48763C21.4097 7.50425 21.4138 7.52105 21.4174 7.538C21.4721 7.77114 21.5 8.01057 21.5 8.25164V18.375C21.5 20.1009 20.1009 21.5 18.375 21.5H5.625C3.89911 21.5 2.5 20.1009 2.5 18.375V8.25164C2.5 8.01058 2.52789 7.77116 2.58257 7.53804C2.58623 7.52106 2.59033 7.50424 2.59484 7.48759C2.64989 7.26928 2.72855 7.05683 2.82992 6.8541L4.29007 3.93379ZM4.5 8.75V18.375C4.5 18.9963 5.00368 19.5 5.625 19.5H18.375C18.9963 19.5 19.5 18.9963 19.5 18.375V8.75H4.5ZM18.882 6.75H5.11803L6.07893 4.82822C6.1795 4.62706 6.3851 4.5 6.60999 4.5H17.39C17.6149 4.5 17.8205 4.62706 17.9211 4.82822L18.882 6.75ZM8.5 11.5C8.5 10.9477 8.94772 10.5 9.5 10.5V11.5V12.5C8.94772 12.5 8.5 12.0523 8.5 11.5ZM9.5 11.5V12.5H14.5C15.0523 12.5 15.5 12.0523 15.5 11.5C15.5 10.9477 15.0523 10.5 14.5 10.5H9.5V11.5Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
